import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { ArrowLeft, ExternalLink, Coins } from "lucide-react";

export default function SocialRewards() {
  const [platforms, setPlatforms] = useState([]);
  useEffect(() => { api.get("/rules/social-rewards").then(r => setPlatforms(r.data?.platforms || [])); }, []);

  return (
    <div className="px-4 py-6 pb-24" data-testid="social-rewards-page">
      <Link to="/more" className="flex items-center gap-1 text-xs text-white/60 mb-3" data-testid="social-back"><ArrowLeft className="w-3.5 h-3.5"/>Back</Link>
      <div className="flex items-center gap-2 mb-1">
        <Coins className="w-7 h-7 text-[#FF7A00]"/>
        <h1 className="font-outfit font-extrabold text-3xl tracking-tighter">Follow &amp; Earn</h1>
      </div>
      <p className="text-white/60 text-sm mb-5">Engage with Hifireels on YouTube, Instagram &amp; Facebook to boost your Goldly wallet.</p>

      <div className="space-y-4" data-testid="platforms-list">
        {platforms.map(p => (
          <div key={p.platform} data-testid={`platform-${p.platform.toLowerCase()}`}
            className="rounded-3xl border bg-white/5 overflow-hidden"
            style={{ borderColor: `${p.color}55` }}>
            <div className="p-4 flex items-center justify-between" style={{ background: `linear-gradient(135deg, ${p.color}22, transparent)` }}>
              <div className="flex items-center gap-2.5">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center text-2xl" style={{ background: `${p.color}33` }}>{p.icon}</div>
                <div>
                  <div className="font-outfit font-extrabold text-lg" style={{ color: p.color }}>{p.platform}</div>
                  <div className="text-[10px] text-white/60">Tap each action to open in {p.platform}</div>
                </div>
              </div>
              <a href={p.url} target="_blank" rel="noopener noreferrer"
                data-testid={`open-${p.platform.toLowerCase()}`}
                className="p-2 rounded-full bg-white/10 border border-white/20 active:scale-95">
                <ExternalLink className="w-4 h-4 text-white"/>
              </a>
            </div>
            <div className="p-3 space-y-2">
              {p.actions.map((a, i) => (
                <div key={i} data-testid={`platform-action-${p.platform.toLowerCase()}-${i}`}
                  className="flex items-center gap-2 p-2.5 rounded-xl bg-white/5 border border-white/10">
                  <div className="flex-1 text-sm text-white/90">{a.action}</div>
                  <div className="text-right flex-shrink-0">
                    <div className="font-outfit font-extrabold text-base text-[#FF7A00]">+{a.reward}</div>
                    <div className="text-[9px] text-white/40 uppercase tracking-wider">Goldly</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 rounded-2xl p-4 border border-emerald-400/30 bg-emerald-500/5">
        <h3 className="font-bold text-sm text-emerald-300 mb-1">How to claim</h3>
        <p className="text-xs text-white/70 leading-relaxed">After you follow / like / comment on any official Hifireels page, send a screenshot to Admin via <Link to="/dm/admin" className="text-emerald-300 underline">DM</Link> with your Hifireels username. Goldly will be credited within 24 hours.</p>
      </div>
    </div>
  );
}
